export const ASSIGNMENT_STATUS_CLASSES = {
  1: "before_start_date",
  2: "after_start_before_due_not_submitted",
  3: "after_start_before_due_submitted",
  4: "after_due_not_submitted",
  5: "after_due_submitted_before_due",
  6: "after_due_submitted_after_due"
};

export const ASSIGNMENT_STATUS_FILTER_GROUPS: { [index: number]: number[] } = {
  0: [1, 2, 3, 4, 5, 6],
  1: [3, 5, 6],
  2: [2],
  3: [4],
  4: [1]
};
